import styled from "styled-components";
import { theme } from "../../../../../../../helpers/theme";


interface ViewVariantsArticleProps {
    phone?: string;
}
export const ViewVariantsArticle = ({ phone }: ViewVariantsArticleProps) => {

    return (
        <ArticleWrapper>
            <Article>
                Na wskazany przez Ciebie numer telefonu
                <strong>{phone ? ` ${phone} ` : ""}</strong> wkrótce zadzwoni
                nasz konsultant.
            </Article>
        </ArticleWrapper>

    );
};

const ArticleWrapper = styled.div`
display:flex;
flex-direction:column;
justyf-content:center;
max-width:325px;
margin-right:auto;
margin-left:auto;
margin-top:16px;
margin-bottom:24px;
`;
const Article = styled.div`
font-family:  ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 16px;
line-height: 24px;
text-align: center;
color: ${theme.colors.gray01_secondaryText};
& strong{
    color: ${theme.colors.blue02_hover};
    font-weight: 400;
}
`